import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <p>
      🍻 May your code be bug-free & your quests legendary!
      <br />
      &copy; {new Date().getFullYear()} JO Codes. All rights reserved.
    </p>
  </footer>
);

export default Footer;
